import React from "react";
import { Box } from "@curves/ui-base";
import imgPdf from "@icoach/assets/img/pdf.png";
import useShowPDF from "@util/hook/useShowPDF";
import { isFunction } from "@util/utils";

const ActivityRecordCardPdfAttachment = ({ pdfUrl, onClick = null }) => {
	const showPDF = useShowPDF();

	const handleClick = (e) => {
		showPDF({
			open: true,
			pdfUrl,
		});
		isFunction(onClick) && onClick(e);
	};

	return (
		<Box className="activity-record-card__pdf-attachment" onClick={handleClick}>
			<img src={imgPdf} alt="PDF 預覽" />
		</Box>
	);
};

export default ActivityRecordCardPdfAttachment;
